import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fmtUSD } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.06 }}
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/shop/${product.slug}`} className="group block">
        <div className="relative aspect-square rounded-3xl bg-gradient-to-br from-sky-50 to-white overflow-hidden">
          <img
            src={product.image}
            alt={product.name}
            className="absolute inset-0 w-full h-full object-contain p-6 transition-transform duration-500 group-hover:scale-105"
          />
          {product.badge && (
            <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-amber-400 text-[#173a7a] text-[11px] font-extrabold uppercase tracking-wider">
              {product.badge}
            </span>
          )}
          {product.compare_at && (
            <span className="absolute top-4 right-4 px-3 py-1 rounded-full bg-white text-[#173a7a] text-[11px] font-extrabold uppercase tracking-wider shadow-sm">
              Save {fmtUSD(product.compare_at - product.price)}
            </span>
          )}
        </div>
        <div className="mt-4 px-1">
          <p className="text-[11px] uppercase tracking-widest text-slate-400 font-bold">{product.category.replace(/-/g, " ")}</p>
          <p className="font-display text-lg font-bold text-slate-900 mt-1 group-hover:text-[#173a7a] transition-colors">
            {product.name}
          </p>
          <p className="text-sm text-slate-500 mt-1 line-clamp-1">{product.short}</p>
          <div className="mt-3 flex items-center gap-2">
            <span className="font-bold text-slate-900">{fmtUSD(product.price)}</span>
            {product.compare_at && (
              <span className="text-sm text-slate-400 line-through">{fmtUSD(product.compare_at)}</span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
